import { render, staticRenderFns } from "./LoginForgot.vue?vue&type=template&id=7a90a31a&scoped=true"
import script from "./LoginForgot.vue?vue&type=script&lang=js"
export * from "./LoginForgot.vue?vue&type=script&lang=js"
import style0 from "./LoginForgot.vue?vue&type=style&index=0&id=7a90a31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a90a31a",
  null
  
)

export default component.exports